import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FileText,
  Upload,
  Library,
  MessageSquare,
  ArrowRight,
  Plus,
  BookOpen,
  FileUp,
  Sparkles,
} from "lucide-react";
import { Button } from "@foundation/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@foundation/components/ui/card";
import ScopingAILayout from "../components/RevisrLayout";

export default function ResourceLibraryPage() {
  const navigate = useNavigate();

  // const handleNavigateToDocuments = () => {
  //   navigate("/revisr/resource-library/documents");
  // };

  // const handleNavigateToPrompts = () => {
  //   navigate("/revisr/resource-library/prompts");
  // };

  // const handleNavigateToNewDocument = () => {
  //   navigate("/revisr/documents/new");
  // };



  const handleNavigateToKnowledgeBase = () => {
    navigate("/revisr/revisr-library");
  };

  const handleNavigateToLibrary = () => {
    navigate("/revisr/revisr-library");
  };

  return (
    <ScopingAILayout>
      <div className="max-w-6xl mx-auto px-4 space-y-6 md:space-y-8">
        {/* Header */}
        <div className="bg-background rounded-lg p-4 md:p-8">
          <div className="flex items-center gap-3 mb-4 md:mb-6">
            <div className="bg-primary/10 p-3 rounded-xl">
              <BookOpen className="h-6 w-6 text-primary" />
            </div>
            <h1 className="text-2xl md:text-3xl font-bold text-foreground">
              Reference Library
            </h1>
          </div>
          <p className="text-muted-foreground max-w-2xl text-base md:text-lg mb-6 md:mb-8">
            Your central hub for managing templates, reference standards and compliance source material used by the AI.</p>

          {/* Quick Action Buttons */}
        </div>

        {/* Main Features Grid - Enhanced with Advanced Clean Animations and Improved Spacing */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-2">
          <Card className="group relative overflow-hidden border-primary/10 hover:border-primary/30 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 hover:scale-[1.02] transform-gpu">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <CardHeader className="relative z-10 pb-6 pt-6">
              <div className="flex items-center gap-4 mb-4">
                <div className="bg-primary/10 dark:bg-primary/20 p-3.5 rounded-xl group-hover:bg-primary/20 dark:group-hover:bg-primary/30 transition-all duration-300 group-hover:scale-110">
                  <Library className="h-6 w-6 text-primary transition-transform duration-300 group-hover:rotate-12" />
                </div>
                <CardTitle className="text-xl font-semibold group-hover:text-primary transition-colors duration-300">Templates</CardTitle>
              </div>
              <CardDescription className="text-base leading-relaxed text-muted-foreground px-1">
                Access and manage your proposal templates and generated content for streamlined document creation.
              </CardDescription>
            </CardHeader>
            <CardContent className="relative z-10 pt-0 pb-6 px-6">
              <Button
                onClick={handleNavigateToDocuments}
                variant="outline"
                className="w-full border-primary text-primary hover:bg-primary hover:text-primary-foreground shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 font-medium py-3 mt-2"
              >
                Templates
                <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Button>
            </CardContent>
          </Card>

          <Card className="group relative overflow-hidden border-primary/10 hover:border-primary/30 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 hover:scale-[1.02] transform-gpu">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <CardHeader className="relative z-10 pb-6 pt-6">
              <div className="flex items-center gap-4 mb-4">
                <div className="bg-primary/10 dark:bg-primary/20 p-3.5 rounded-xl group-hover:bg-primary/20 dark:group-hover:bg-primary/30 transition-all duration-300 group-hover:scale-110">
                  <Sparkles className="h-6 w-6 text-primary transition-transform duration-300 group-hover:rotate-12" />
                </div>
                <CardTitle className="text-xl font-semibold group-hover:text-primary transition-colors duration-300">AI Prompts</CardTitle>
              </div>
              <CardDescription className="text-base leading-relaxed text-muted-foreground px-1">
                Customize and optimize your AI prompts for enhanced document
                generation and analysis.
              </CardDescription>
            </CardHeader>
            <CardContent className="relative z-10 pt-0 pb-6 px-6">
              <Button
                onClick={handleNavigateToPrompts}
                variant="outline"
                className="w-full border-primary text-primary hover:bg-primary hover:text-primary-foreground shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 font-medium py-3 mt-2"
              >
                Manage Prompts
                <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Button>
            </CardContent>
          </Card>

          <Card className="group relative overflow-hidden border-primary/10 hover:border-primary/30 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 hover:scale-[1.02] transform-gpu">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <CardHeader className="relative z-10 pb-6 pt-6">
              <div className="flex items-center gap-4 mb-4">
                <div className="bg-primary/10 dark:bg-primary/20 p-3.5 rounded-xl group-hover:bg-primary/20 dark:group-hover:bg-primary/30 transition-all duration-300 group-hover:scale-110">
                  <BookOpen className="h-6 w-6 text-primary transition-transform duration-300 group-hover:rotate-12" />
                </div>
                <CardTitle className="text-xl font-semibold group-hover:text-primary transition-colors duration-300">Your References</CardTitle>
              </div>
              <CardDescription className="text-base leading-relaxed text-muted-foreground px-1">
                Upload documents and chat with your references using advanced AI for intelligent document analysis.
              </CardDescription>
            </CardHeader>
            <CardContent className="relative z-10 pt-0 pb-6 px-6">
              <Button
                onClick={handleNavigateToKnowledgeBase}
                variant="outline"
                className="w-full border-primary text-primary hover:bg-primary hover:text-primary-foreground shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 font-medium py-3 mt-2"
              >
                Your References
                <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Button>
            </CardContent>
          </Card>
        </div> */}

        <div className="px-6 py-8 lg:px-16 xl:px-24">
  {/* Cards Grid with uniform spacing */}
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12 max-w-7xl mx-auto">
    {/* --- Card 1: Templates --- */}
    {/* <Card className="group relative overflow-hidden border border-primary/10 hover:border-primary/30 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 hover:scale-[1.02] transform-gpu rounded-xl">
      // <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-0"></div>

      // <CardHeader className="relative z-10 p-8 pb-6">
      //   <div className="flex items-center gap-4 mb-6">
      //     <div className="bg-primary/10 dark:bg-primary/20 p-3.5 rounded-xl group-hover:bg-primary/20 dark:group-hover:bg-primary/30 transition-all duration-300 group-hover:scale-110">
      //       <Library className="h-6 w-6 text-primary transition-transform duration-300 group-hover:rotate-12" />
      //     </div>
      //     <CardTitle className="text-xl font-semibold group-hover:text-primary transition-colors duration-300 leading-tight">
      //       Templates
      //     </CardTitle>
      //   </div>
      //   <CardDescription className="text-base text-muted-foreground leading-relaxed min-h-[3rem] flex items-center">
      //     Manage proposal templates and content for faster, streamlined document creation
      //   </CardDescription>
      // </CardHeader>

      <CardContent className="relative z-10 px-8 pt-0 pb-8">
        <Button
          onClick={handleNavigateToDocuments}
          variant="outline"
          className="w-full border-primary text-primary hover:bg-primary hover:text-primary-foreground shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 font-medium py-3.5 mt-6"
        >
          Templates
          <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Button>
      </CardContent>
    </Card> */}

    {/* --- Card 2: Revisr Library --- */}
    <Card className="group relative overflow-hidden border border-primary/10 hover:border-primary/30 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 hover:scale-[1.02] transform-gpu rounded-xl">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-0"></div>

      <CardHeader className="relative z-10 p-6 pb-4">
        <div className="flex items-center gap-4 mb-4">
          <div className="bg-primary/10 dark:bg-primary/20 p-3.5 rounded-xl group-hover:bg-primary/20 dark:group-hover:bg-primary/30 transition-all duration-300 group-hover:scale-110">
            <Library className="h-6 w-6 text-primary transition-transform duration-300 group-hover:rotate-12" />
          </div>
          <CardTitle className="text-xl font-semibold group-hover:text-primary transition-colors duration-300 leading-tight">
            Revisr Library
          </CardTitle>
        </div>
        <CardDescription className="text-base text-muted-foreground leading-relaxed min-h-[3rem] flex items-center">
          See our library of preloaded templates, standards and reference.
        </CardDescription>
      </CardHeader>

      <CardContent className="relative z-10 px-6 pt-0 pb-6">
        <Button
          onClick={handleNavigateToLibrary}
          variant="outline"
          className="w-full border-primary text-primary hover:bg-primary hover:text-primary-foreground shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 font-medium py-3.5 mt-4"
        >
          Browse Library
          <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Button>
      </CardContent>
    </Card>

    {/* --- Card 3: Your References --- */}
    <Card className="group relative overflow-hidden border border-primary/10 hover:border-primary/30 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 hover:scale-[1.02] transform-gpu rounded-xl">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-0"></div>

      <CardHeader className="relative z-10 p-6 pb-4">
        <div className="flex items-center gap-4 mb-4">
          <div className="bg-primary/10 dark:bg-primary/20 p-3.5 rounded-xl group-hover:bg-primary/20 dark:group-hover:bg-primary/30 transition-all duration-300 group-hover:scale-110">
            <BookOpen className="h-6 w-6 text-primary transition-transform duration-300 group-hover:rotate-12" />
          </div>
          <CardTitle className="text-xl font-semibold group-hover:text-primary transition-colors duration-300 leading-tight">
            Your References
          </CardTitle>
        </div>
        <CardDescription className="text-base text-muted-foreground leading-relaxed min-h-[3rem] flex items-center">
          Upload standards and reference docs by industry to train your workspace and keep your compliance reviews accurate.
        </CardDescription>
      </CardHeader>

      <CardContent className="relative z-10 px-6 pt-0 pb-6">
        <Button
          onClick={handleNavigateToKnowledgeBase}
          variant="outline"
          className="w-full border-primary text-primary hover:bg-primary hover:text-primary-foreground shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 font-medium py-3.5 mt-4"
        >
          Your References
          <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Button>
      </CardContent>
    </Card>
  </div>
</div>


      </div>
    </ScopingAILayout>
  );
}
